import { render, staticRenderFns } from "./all-serial.vue?vue&type=template&id=55aa4be8&"
import script from "./all-serial.vue?vue&type=script&lang=js&"
export * from "./all-serial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports